import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { projects } from '../data/projectsData';
import './ProjectDetail.css';

function ProjectDetail() {
  const { id } = useParams();
  const project = projects.find(p => p.id === parseInt(id));

  if (!project) {
    return (
      <div className="project-detail">
        <div className="project-not-found">
          <p>Projet non trouvé</p>
          <Link to="/portfolio">Retour au portfolio</Link>
        </div>
      </div>
    );
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  return (
    <motion.div 
      className="project-detail"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="project-detail-container">
        <motion.div variants={itemVariants}>
          <Link to="/portfolio" className="project-back">
            ← Retour
          </Link>
        </motion.div>
        <motion.h1 
          className="project-title"
          variants={itemVariants}
        >
          {project.title}
        </motion.h1>
        <div className="project-content">
          <motion.div 
            className="project-image-wrapper"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: [0.4, 0, 0.2, 1] }}
          >
            <div className="project-image-container">
              <motion.img 
                src={project.coverImage || project.image} 
                alt={project.title}
                className="project-image"
                whileHover={{ scale: 1.01 }}
                transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
              />
            </div>
            {project.colors && project.colors.length > 0 && (
              <div className="project-color-palette project-color-palette-desktop">
                {project.colors.map((color, index) => (
                  <div key={index} className="project-color-circle">
                    <div 
                      className="project-color-inner"
                      style={{ backgroundColor: color }}
                    />
                  </div>
                ))}
              </div>
            )}
          </motion.div>
          <motion.div 
            className="project-info project-info-desktop"
            variants={containerVariants}
          >
            <div className="project-meta">
              <motion.div 
                className="project-meta-item"
                variants={itemVariants}
              >
                <span className="project-meta-label">Contexte</span>
                <span className="project-meta-value">{project.context}</span>
              </motion.div>
              <motion.div 
                className="project-meta-item"
                variants={itemVariants}
              >
                <span className="project-meta-label">Rôle</span>
                <span className="project-meta-value">{project.role}</span>
              </motion.div>
              <motion.div 
                className="project-meta-item"
                variants={itemVariants}
              >
                <span className="project-meta-label">Année</span>
                <span className="project-meta-value">{project.year}</span>
              </motion.div>
            </div>
          </motion.div>
          <div className="project-mobile-layout">
            <div className="project-info project-info-mobile">
              <div className="project-meta">
                <div className="project-meta-item">
                  <span className="project-meta-label">Contexte</span>
                  <span className="project-meta-value">{project.context}</span>
                </div>
                <div className="project-meta-item">
                  <span className="project-meta-label">Rôle</span>
                  <span className="project-meta-value">{project.role}</span>
                </div>
                <div className="project-meta-item">
                  <span className="project-meta-label">Année</span>
                  <span className="project-meta-value">{project.year}</span>
                </div>
              </div>
            </div>
            {project.colors && project.colors.length > 0 && (
              <div className="project-color-palette project-color-palette-mobile">
                {project.colors.map((color, index) => (
                  <div key={index} className="project-color-circle">
                    <div 
                      className="project-color-inner"
                      style={{ backgroundColor: color }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {project.description && (
          <motion.p 
            className="project-description"
            variants={itemVariants}
          >
            {project.description}
          </motion.p>
        )}
        {project.image && (
          <motion.div 
            className="project-detail-image-section"
            variants={itemVariants}
          >
            <img 
              src={project.image} 
              alt={project.title}
              className="project-detail-image"
            />
          </motion.div>
        )}
      </div>
    </motion.div>
  );
}

export default ProjectDetail;

